export const mapStateMetricsConfig = {
  bearing: 18.84375,
  dragRotate: true,
  latitude: 39.23081874424652,
  longitude: 9.112565449928983,
  pitch: 6.693334238491111,
  zoom: 11.511760486598547,
  isSplit: false,
};
